<template>
  <div 
    :class="{
      'w-full': props.size === 'small-full',
      'md:w-[250px]': props.size === 'small',
      'md:w-[352px]': props.size === 'large',
      'max-w-full w-full': props.size === 'full',
    }"
  >
    <header class="relative p-3 w-full aspect-square">
      <NuxtImg
        class="object-cover absolute inset-0 size-full"
        loading="lazy"
        :src="meetingType.photo1"
      />
      <EventTypeTag
        class="relative"
        :eventType="meetingType.eventType"
        :eventTag="meetingType.typeTag"
      />
    </header>
    <div class="flex flex-col my-5 gap-4">
      <h1
        class="line-clamp-2"
        :class="{
          'text-4xl': ['large', 'full'].includes(props.size),
          'text-3xl': ['small', 'small-full'].includes(props.size),
        }"
        v-tooltip.top="{value: meetingType.name, showDelay: 1000, class: 'card-tooltip'}"
      >
        {{ meetingType.name }}
      </h1>
    </div>
    <div class="flex flex-col items-start">
      <div class="flex flex-col items-start gap-1.5">
        <InstructorsStack 
          :openInstructorsModal="openInstructorsModal"
          :instructors="meetingType.instructors" size="20px" 
          :inline="true"
        />
        <div class="flex flex-row mt-4 items-center flex-wrap">
          <EventDate :date="meetingType.dateShort" />
          <span class="mx-3">•</span>
          <EventDuration :duration="meetingType.duration_minutes" />
        </div>
      </div>
      <NuxtLink 
        :to="`/sessions/${meetingType.wwwSlug}`" 
        :target="props.openInNewWindow ? '_blank' : ''"
        class="text-primary underline mt-5"
      >
        <span>
          Book Now
        </span>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import EventDate from '@/components/events/EventDate.vue';
import EventDuration from '@/components/events/EventDuration.vue';
import InstructorsStack from '@/components/events/InstructorsStack.vue';
import EventTypeTag from '@/components/events/EventTypeTag.vue';

const props = withDefaults(defineProps<{
  meetingType: MeetingTypeDetails,
  size?: 'small' | 'small-full' | 'large' | 'full',
  openInstructorsModal?: boolean,
  openInNewWindow?: boolean
}>(), {
  size: 'large',
  openInstructorsModal: true,
  openInNewWindow: false
})
</script>

<style>
.card-tooltip {
--p-tooltip-max-width: 300px;
--p-tooltip-bg: var(--p-color-dark);
}
</style>